import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Button, Card, CardHeader, CardText } from '@unite-us/app-components';
import { InReviewModal } from 'common/Workqueue/InReviewModal';
import { LineItem } from 'common/display/LineItem';
import classNames from 'classnames';

export const ReviewReasonDetailsCard = ({
  reviewReason,
  inReviewNote,
  assignee,
  onSubmit,
  assigneeOptions,
  reviewReasonOptions,
  requiresEnrollmentDrawerClass,
}) => {
  const modalRef = useRef(null);

  const handleOpenModalClick = () => {
    if (modalRef.current) {
      modalRef.current.openModal();
    }
  };

  const initialFormValues = {
    review_reason: reviewReason?.id,
    in_review_note: inReviewNote,
    assignee: assignee?.id,
  };

  const dlClass = classNames({
    'ml-1 m-0 grid grid-cols-2 gap-y-2 gap-x-8': requiresEnrollmentDrawerClass,
    'm-0 grid grid-cols-4 gap-y-2 gap-x-8': !requiresEnrollmentDrawerClass,
  });
  const valueClass = classNames({
    'col-span-1 ml-6': requiresEnrollmentDrawerClass,
    'col-span-3 ml-2': !requiresEnrollmentDrawerClass,
  });

  return (
    <Card className="border border-solid rounded border-orange">
      <CardHeader
        title="Review Details"
        className="flex justify-between items-center"
        titleStyle={{
          fontWeight: 'bold',
        }}
      >
        <Button
          onClick={handleOpenModalClick}
          label="Edit Review Details"
          link
          size="small"
          icon={{
            color: '#4467AB',
            name: 'Pencil',
            position: 'left',
          }}
        />
      </CardHeader>
      <CardText className="space-y-3 rounded-b bg-white overflow-y-scroll">
        <dl className={dlClass}>
          <LineItem
            field="Reason for Review"
            valueClassName={valueClass}
          >
            {reviewReason?.reason || 'Not specified'}
          </LineItem>
          <LineItem
            field="Notes"
            valueClassName={valueClass}
          >
            {inReviewNote || 'Not specified'}
          </LineItem>
        </dl>
      </CardText>
      <InReviewModal
        ref={modalRef}
        title="Edit review details"
        onSubmit={onSubmit}
        assigneeOptions={assigneeOptions}
        reviewReasonOptions={reviewReasonOptions}
        initialFormValues={initialFormValues}
      />
    </Card>
  );
};

ReviewReasonDetailsCard.propTypes = {
  reviewReason: PropTypes.shape({
    reason: PropTypes.string,
    id: PropTypes.string,
  }).isRequired,
  inReviewNote: PropTypes.string.isRequired,
  assignee: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  onSubmit: PropTypes.func.isRequired,
  assigneeOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  reviewReasonOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  requiresEnrollmentDrawerClass: PropTypes.bool,
};

ReviewReasonDetailsCard.defaultProps = {
  assignee: null,
  requiresEnrollmentDrawerClass: false,
};
